import type { HeySynclyPromptLibraryItem } from '@/entities/hey-syncly';

export type PromptLibraryItem = HeySynclyPromptLibraryItem;

export const PAGE_SIZE = 5;
export const MAX_CUSTOM_PROMPT_COUNT = 30;
